import React from 'react';
import { Grid, Typography, Box, List, ListItem, ListItemText, Paper, Button } from '@mui/material';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';

export default function GrowResto({ isMobile, language, translations, scrollToSection, contactusRef }: { isMobile: boolean, language: any, translations: any, scrollToSection: any, contactusRef: any }) {
    const dictionary = getDictionary(translations, 'customer-base', language);
    const isArabic = language === 'arabic';

    return (
        <>
            <Box className="section-light-purple-bg" style={{ width: "100%", display: "flex", justifyContent: isMobile ? "space-between" : "center" }}>
                <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"} style={{ width: isMobile ? "100%" : "80%" }}>
                    <Grid item xs={12} md={6} >
                        <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            {getSvg('growrestoarrow', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 80, height: 80 }, { 
                                position: 'absolute', 
                                transform: isArabic ? "translate(-9rem , -3rem)" : "translate(1rem , -4rem)" 
                            })}
                            <div >
                                <div style={{ position: 'relative', zIndex: 0 }}>
                                    <Typography paragraph fontWeight="bold" fontSize={"20px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                        {getField(dictionary, 'title', language)}
                                    </Typography>
                                </div>

                            </div>
                            <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                {getField(dictionary, 'list-title-one', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: "1px", letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-one', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                {getField(dictionary, 'list-title-two', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-two', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                {getField(dictionary, 'list-title-three', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-three', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                            </List>
                            <Button
                                variant='contained'
                                sx={{
                                    backgroundColor: "var(--accent-primary)",
                                    color: "white",
                                    marginTop: "10px",
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: "var(--accent-primary)",
                                    },
                                }}
                            >  <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                                    {getField(dictionary, 'start-building-your-crm', language)}
                                </a>

                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} >
                        <Box display="flex" justifyContent="center">
                            <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/customerBase.webp`} loading="lazy" width="100%" height="100%" alt="Customer Base" />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

        </>
    );
}
